export const getBoundingBox = (el) => {
    const r = el.getBoundingClientRect();
    return {
        x: r.x,
        y: r.y,
        width: r.width,
        height: r.height,
    };
};
export const rectsIntersect = (el, region) => {
    const r = el.getBoundingClientRect();
    const noOverlap = r.right < region.x ||
        r.left > region.x + region.width ||
        r.bottom < region.y ||
        r.top > region.y + region.height;
    return !noOverlap;
};
export const isPositionFixed = (el) => {
    const view = el.ownerDocument?.defaultView ?? window;
    const cs = view.getComputedStyle(el);
    return cs.position === "fixed" || cs.position === "sticky";
};
//# sourceMappingURL=boundingBox.js.map